module.exports = __webpack_public_path__ + "img/qrcode.6ef7ad8a.jpg";